import {
  Button,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
} from "@chakra-ui/react";
import { listChains } from "configs/chain";
import { listScreenBlock } from "configs/screenBlock";
import { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import useAddBlacklist from "../hooks/useAddBlacklist";

interface IProps {
  isOpen: boolean;
  currentId: any;
  onClose: () => void;
}
export default function ModalAddBlacklist({
  isOpen,
  currentId,
  onClose,
}: IProps) {
  const {
    handleSubmit,
    register,
    control,
    reset,
    formState: { errors },
  } = useForm({});
  const { isLoading, mutate } = useAddBlacklist({
    onClose,
    reset,
    id: currentId?._id,
  });

  useEffect(() => {
    reset({
      chainId: currentId?.chainId,
      address: currentId?.address,
      screen: currentId?.screen,
      description: currentId?.description,
    });
  }, [currentId, reset]);

  const onSubmit = (values: any) => {
    mutate(values);
  };
  const handleClose = () => {
    onClose();
    reset();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Block a token</ModalHeader>
        <ModalCloseButton />

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <ModalBody pb={6}>
            <Controller
              name="chainId"
              control={control}
              render={({ field: { ref, ...rest }, fieldState: { error } }) => (
                <FormControl isInvalid={Boolean(error?.message)} isRequired>
                  <FormLabel>Chain</FormLabel>
                  <Select placeholder="Select Chain" {...rest}>
                    {listChains.map((chain) => (
                      <option key={chain.value} value={chain.value}>
                        {chain.name}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage>
                    <>{error?.message}</>
                  </FormErrorMessage>
                </FormControl>
              )}
              rules={{
                required: {
                  value: true,
                  message: "This is required",
                },
              }}
            />

            <FormControl mt={4} isInvalid={Boolean(errors.address)} isRequired>
              <FormLabel>Address</FormLabel>
              <Input
                placeholder="Address"
                {...register("address", {
                  required: "This is required",
                })}
              />
              <FormErrorMessage>
                <>{errors?.address?.message}</>
              </FormErrorMessage>
            </FormControl>

            <FormControl mt={4} isInvalid={Boolean(errors.description)}>
              <FormLabel>Description</FormLabel>
              <Input
                placeholder="Description"
                {...register("description", {})}
              />
              <FormErrorMessage>
                <>{errors?.description?.message}</>
              </FormErrorMessage>
            </FormControl>

            <Controller
              name="screen"
              control={control}
              render={({ field: { ref, ...rest }, fieldState: { error } }) => (
                <FormControl mt={4} isInvalid={Boolean(error?.message)}>
                  <FormLabel>Block screen</FormLabel>
                  <CheckboxGroup colorScheme="blue" {...rest}>
                    <Stack>
                      {listScreenBlock.map((el) => (
                        <Checkbox key={el.value} value={el.value}>
                          {el.name}
                        </Checkbox>
                      ))}
                    </Stack>
                  </CheckboxGroup>
                  <FormErrorMessage>
                    <>{error?.message}</>
                  </FormErrorMessage>
                </FormControl>
              )}
              rules={{
                required: {
                  value: true,
                  message: "Please select at least one",
                },
              }}
            />
          </ModalBody>

          <ModalFooter>
            <Button
              mr={4}
              colorScheme="blue"
              isLoading={isLoading}
              type="submit"
            >
              Submit
            </Button>
            <Button onClick={handleClose}>Cancel</Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
